import type { DocTypeSchema, DocFieldSchema } from "@/lib/erp/meta";
import { CHILD_TABLE_META_FIELDNAMES } from "./validation";

/**
 * Shared helper: filter a child doctype schema to the visible "business" fields
 * we should render/validate against.
 */
export function getVisibleChildTableFields(schema: DocTypeSchema): DocFieldSchema[] {
  return (schema.fields || []).filter(
    (f) => f.hidden !== 1 && !f.fieldname.startsWith("__") && !CHILD_TABLE_META_FIELDNAMES.has(f.fieldname)
  );
}

